import { render, staticRenderFns } from "./DeepCatchUp.vue?vue&type=template&id=783c4fc2&scoped=true&"
import script from "./DeepCatchUp.vue?vue&type=script&lang=js&"
export * from "./DeepCatchUp.vue?vue&type=script&lang=js&"
import style0 from "./DeepCatchUp.vue?vue&type=style&index=0&id=783c4fc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783c4fc2",
  null
  
)

export default component.exports